import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {InterventionInstance} from '../models/interventionInstance.model';

@Injectable({
  providedIn: 'root'
})
export class InterventionInstanceService {

  private api:string = environment.api+'/InterventionInstances';
  constructor(private http: HttpClient) { }

  public getAllInterventionInstances(pageNo:number,pageSize:number){
    return this.http.get(this.api+'/getAll?pageNo='+pageNo+'&pageSize='+pageSize);
  }

  public updateInterventionInstance(interventionInstance:InterventionInstance){
    return this.http.put(this.api,interventionInstance);
  }

  public deleteInterventionInstance(interventionInstance:InterventionInstance){
    return this.http.delete(this.api+'/'+interventionInstance.interventionInstanceId);
  }
}
